import { Button } from '@material-ui/core'
import axios from 'axios'
import React from 'react'

const ConfirmBranchDelete = props => {
    const deleteHandler = () => {
        axios({
            url: 'accounts/branch/',
            method: "delete",
            data: {
                id: props.id
            }
        }).then(() => {
            props.setBranchesState(props.branchesState.filter(branch => branch.id !== props.id))
            props.setPopup(false)
        })
    }

    return (
        <>
            <Button
                type="submit"
                variant="contained"
                color="secondary"
                style={{ margin: 10 }}
                onClick={deleteHandler}
            >
                بله
                </Button>
            <Button
                type="submit"
                variant="contained"
                color="primary"
                style={{ margin: 10 }}
                onClick={() => props.setPopup(false)}
            >
                خیر
            </Button>
        </>
    )
}

export default ConfirmBranchDelete
